'use client';

import { __styles, mergeClasses } from "@griffel/react";
export const teachingPopoverCarouselClassNames = {
  root: 'fui-TeachingPopoverCarousel'
};
// Todo: Page change animation & styles
const useStyles = /*#__PURE__*/__styles({
  root: {}
}, {});
/** Applies style classnames to slots */
export const useTeachingPopoverCarouselStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(teachingPopoverCarouselClassNames.root, styles.root, state.root.className);
  return state;
};